import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

// 从 localStorage 读取组件大小设置
const savedSize = localStorage.getItem('componentSize') || 'medium'

// 配置 Element UI 的全局 size
Vue.use(ElementUI, {
  size: savedSize
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

